export const getStyles = (
  font: string,
  fontMedium: string,
  subtitle: string
) => ({
  title: `${fontMedium} mb-4 text-black`,
  subtitle: `${fontMedium} mb-2 xl:mb-0 text-14 leading-20 ${subtitle} xl:leading-40 text-black`,
  text: `${font} last-of-type:mb-6 text-14 leading-20 leading-24`
})
